// Query keys for React Query caching and invalidation
export const tenantQueryKeys = {
  // Domain queries (Institutes)
  domains: (tenantId: string) => ['tenant', tenantId, 'domains'] as const,
  domain: (domainId: string) => ['tenant', 'domain', domainId] as const,

  // University Admin queries
  universityAdmins: (tenantId: string) => ['tenant', tenantId, 'universityAdmins'] as const,
  universityAdmin: (userId: string) => ['tenant', 'universityAdmin', userId] as const,

  // Tenant info queries
  tenantInfo: (tenantId: string) => ['tenant', tenantId, 'info'] as const,

  // User existence check
  userExists: (email: string) => ['tenant', 'userExists', email] as const,
} as const;
